export default {
    // host:"wxtest.qungouda88.com",
    // host:"localhost:59190",
    // host:"mcouponapi.jointerest.cn/api2",
    // host:"mcouponapi.jointerest.cn",
    login_key:"app_login_user_ditch",
    debug:false,
    default_aid :4,
    app_params_key:"app_params_8_ditch"
};